export default "__VITE_ASSET__F6klfa2U__"